import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../Header/Header';
import Footer from '../../Footer/Footer';
import './About.css';

const About = () => {
  // 添加这段代码确保页面加载时滚动到顶部
  useEffect(() => {
    // 强制滚动到顶部，设置固定延迟确保DOM完全加载
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }, 0);
  }, []);
  
  return (
    <div className="elegant-app">
      <Header />
      
      <main className="elegant-about-container">
        <div className="elegant-about-header">
          <h1 className="elegant-about-title">关于我们</h1>
          <p className="elegant-about-subtitle">灌汤社区 HugTub：全球首个海龟汤分享社区，启迪思维新境界</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>关于灌汤社区 HugTub</h2>
          <p>
            灌汤社区 HugTub 是一个专注于海龟汤游戏的社区平台。作为全球首个海龟汤分享社区，HugTub 旨在为用户提供一个创作与娱乐兼备的空间。在这里，用户不仅可以分享和讨论各种有趣的海龟汤故事，还可以通过互动创作激发自己的逻辑思维和创造力。无论你是解谜高手还是故事爱好者，HugTub 都能为你提供一个充满乐趣与挑战的空间。我们致力于打造一个全球领先的逻辑推理和故事创作平台，让每一位用户都能在一个充满创意和挑战的环境中成长。
          </p>
        </div>
        
        <div className="elegant-about-section">
          <h2>我们的创始人</h2>
          <p>
            我们的四位创始人（Ethan Zhang、PaiPai Ding、Roger Yuan、Nathan Sun）都怀揣着共同的目标：通过技术创新改变世界。团队成员不仅在学校中表现出色，还积极参加各种编程和技术竞赛，积累了丰富的实践经验。正是这种热情和努力，推动了 HugTech 的成立和发展。
          </p>
          
          <div className="elegant-founders-grid">
            <div className="elegant-founder-card">
              <div className="elegant-founder-avatar">
                <img src="./images/founders/ethan-zhang.jpg" alt="Ethan Zhang" />
              </div>
              <h3>Ethan Zhang</h3>
              <p>联合创始人</p>
            </div>
            <div className="elegant-founder-card">
              <div className="elegant-founder-avatar">
                <img src="./images/founders/paipai-ding.jpg" alt="PaiPai Ding" />
              </div>
              <h3>PaiPai Ding</h3>
              <p>联合创始人</p>
            </div>
            <div className="elegant-founder-card">
              <div className="elegant-founder-avatar">
                <img src="./images/founders/roger-yuan.jpg" alt="Roger Yuan" />
              </div>
              <h3>Roger Yuan</h3>
              <p>联合创始人</p>
            </div>
            <div className="elegant-founder-card">
              <div className="elegant-founder-avatar">
                <img src="./images/founders/nathan-sun.jpg" alt="Nathan Sun" />
              </div>
              <h3>Nathan Sun</h3>
              <p>联合创始人</p>
            </div>
          </div>
        </div>
        
        <div className="elegant-about-section">
          <h2>我们的使命</h2>
          <p>
            HugTech 的使命是通过技术创新推动社会进步，鼓励更多的年轻人参与到科技创造中来。我们相信，每一个创意都有可能改变世界，而每一位年轻的梦想家都值得拥有实现梦想的机会。通过我们的努力，希望能在全球范围内推广逻辑思维和创造性解决问题的能力。
          </p>
        </div>
        
        <div className="elegant-about-section">
          <h2>我们的愿景</h2>
          <p>
            我们的愿景是成为全球领先的青少年科技创新公司，通过持续的技术创新和教育推广，激发年轻一代的创造力和想象力。我们希望通过 HugTech 的努力，培养出更多具有创新精神和社会责任感的未来领袖。
          </p>
        </div>
        
        <div className="elegant-about-section">
          <h2>加入我们</h2>
          <p>
            欢迎访问我们的网站，了解更多信息并见证我们的成长与发展。无论你是创作者、解谜爱好者还是教育工作者，这里都有适合你的内容和机会。让我们共同创造一个充满智慧和乐趣的未来！
          </p>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default About; 